import React from 'react';
import { Box } from '@mui/material';
import { Switch } from '../switch';
import { ColorPalette } from '../config';
import { ISummaPreview } from '../../hooks/ai-search/use-chat';
import { SummaPreviewSwitch } from './summa-preview';

export interface ISummaSettingsProps {
  draftsAvailable: boolean;
  showDrafts: boolean;
  onShowDraftsChange: (checked: boolean) => void;
  previewAvailable: boolean;
  offeredPreview?: ISummaPreview;
  preview?: ISummaPreview;
  hasAnswers: boolean;
  isLoading: boolean;
  onSwitchPreview: (nextPreview?: ISummaPreview) => void;
}

export function SummaSettings(props: ISummaSettingsProps) {
  const { draftsAvailable, showDrafts, onShowDraftsChange, previewAvailable, offeredPreview, preview, hasAnswers, isLoading, onSwitchPreview } = props;

  function handleShowDraftsChange(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    onShowDraftsChange(checked);
  }

  // Ops can withdraw the coming model at any time, so the setting says so rather than disappearing.
  function renderPreviewChoice() {
    if (!preview && !offeredPreview) {
      return <Box sx={{ color: ColorPalette.SecondaryTextColor }}>Ingen kommende model kan afprøves lige nu.</Box>;
    }

    return <SummaPreviewSwitch offeredPreview={offeredPreview} preview={preview} hasAnswers={hasAnswers} isLoading={isLoading} onSwitch={onSwitchPreview} />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {draftsAvailable && <Switch label="Vis kladder" checked={showDrafts} onChange={handleShowDraftsChange} dense />}
      {previewAvailable && renderPreviewChoice()}
    </Box>
  );
}
